import React from "react";
import { useNavigate } from "react-router-dom";
import { useLaunchParams } from "@telegram-apps/sdk-react";
import { NewReferralScreen } from "@/components/NewReferralScreen";
import { ReferralBottomNav } from "@/components/ReferralBottomNav";
import { useReferrals } from "@/providers/ReferralsProvider";
import { useUserEvents, useUserStats } from "@/hooks/useLeaderboard";

/**
 * Mobile version of the Referrals page - maintains original mobile-optimized design
 */
export const ReferralsPageMobile: React.FC = () => {
  const navigate = useNavigate();
  const launchParams = useLaunchParams();
  const userId = launchParams.initData?.user?.id?.toString();
  const { data, user, isWhitelisted, handleCopyCode, handleShareCode } =
    useReferrals();
  const { data: events } = useUserEvents(userId);
  const { data: userStats } = useUserStats(userId);

  if (!data || !user) {
    return null;
  }

  const referralCode = data.referralStats.referralCode;
  const userPoints = userStats?.totalPoints ?? 0;

  // Whitelisted users get bottom nav and header
  if (isWhitelisted) {
    return (
      <div className="min-h-screen bg-primary flex flex-col">
        <div className="flex-1 overflow-y-auto">
          <NewReferralScreen
            referralCode={referralCode}
            referralCount={data.referralStats.totalReferrals}
            userRank={data.referralStats.userRank}
            codeNeedsRefresh={data.referralStats.codeNeedsRefresh}
            codeUsedCount={data.referralStats.codeUsedCount}
            codeMaxUses={data.referralStats.codeMaxUses}
            onGenerateNewCode={() => navigate("/generate-new-code")}
            onShowLeaderboard={() => navigate("/leaderboard")}
            onCopyCode={handleCopyCode}
            onShareCode={handleShareCode}
            canUseCode={data.referralStats.canUseCode}
            events={events?.sort(
              (a, b) =>
                new Date(b?.lastCompletedAt ?? "").getTime() -
                new Date(a?.lastCompletedAt ?? "").getTime()
            )}
            onShowEvents={() => navigate("/events")}
            userPoints={userPoints}
            userMultiplier={
              userStats?.multiplier ? userStats.multiplier / 100 : 1
            }
          />
        </div>
        <ReferralBottomNav />
      </div>
    );
  }

  return null;
};
